module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/checkBlueCM.7f81e3ab.svg";